React = require 'react'
CreateBoardView = require 'views/board/create-board-view'
CreateBoardComponent = require 'views/board-create/create-board-component'
Dialog = require 'views/lib/dialog'
PopOver = require 'views/lib/pop-over'
getExperiment = require 'lib/experiments/simple-test'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/boards_sidebar_searching_buttons'
track = require 'debug/track'

module.exports = class BoardsSidebarSearchingButtonsView extends View
  initialize: ({ searchText }) ->
    @searchText = searchText.map((text) -> text.trim())

  events:
    'click .js-add-board-with-name': 'addBoardWithName'

  renderOnce: ->
    @$el.html template()

    @subscribe @searchText, (text) ->
      @$('.js-add-board-with-name').format 'add board named', { boardName: text }

    @

  addBoardWithName: (e) ->
    Util.stop(e)

    track("Boards Drawer", "Add Board - With Name")

    searchText = @searchText.get()
    withBackground = getExperiment('createBoardWithBackground')?.get('enabled')

    if withBackground
      Dialog.show
        displayType: 'mod-no-chrome'
        opacity: 0.75
        reactElement: React.createElement CreateBoardComponent,
          defaultTitle: searchText
    else
      PopOver.toggle
        elem: @$('.js-add-board-with-name')
        view: CreateBoardView
        options:
          model: @model
          modelCache: @modelCache
          term: searchText

    return



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-searching-buttons-view.coffee